import { Component, ViewChildren, QueryList } from '@angular/core';
import { ToolBarComponent } from '../tool-bar.component';
import { MenuComponent } from '../../../menu/menu.component';

@Component({
    selector: 'data-table-options',
    templateUrl: './data-table-options.component.html',
    styleUrls: ['./data-table-options.component.scss'],
    standalone: false
})
export class DataTableOptionsComponent {
    @ViewChildren(MenuComponent)
    menus: QueryList<MenuComponent>;

    constructor(
        public toolbarComponent: ToolBarComponent
    ) {
        this.toolbarComponent.onClose.subscribe((result) => {
            this.menus.forEach(x => x.close());
        });
    }
}
